export type ParsedAdEntity = {
  entityKind: string;
  displayName: string;
  nodeId: string;
  isCrownJewel: boolean;
  samAccountName?: string;
};

export type ParsedAdEntitiesListOutput = {
  entities: ParsedAdEntity[];
  total?: number;
  entityKind?: string;
};

const ENTITY_LINE_PATTERN =
  /^-\s+\[([^\]]+)\]\s+(.+?)\s+\|\s+nodeId:\s+(\S+)(.*)$/;

function parseEntityLine(line: string): ParsedAdEntity | null {
  const match = line.trim().match(ENTITY_LINE_PATTERN);
  if (!match) {
    return null;
  }

  const [, entityKind, displayName, nodeId, trailing] = match;
  const isCrownJewel = trailing.includes('crown-jewel');
  const samMatch = trailing.match(/\|\s*sam:\s*(\S+)/);

  return {
    entityKind,
    displayName: displayName.trim(),
    nodeId,
    isCrownJewel,
    samAccountName: samMatch?.[1],
  };
}

export function parseAdEntitiesListOutput(
  output: string,
): ParsedAdEntitiesListOutput | null {
  const lines = output.split('\n').map((line) => line.trim());
  const headerMatch = lines[0]?.match(
    /^Found\s+(\d+)\s+of\s+(\d+)\s+(\S+)\s+entities/i,
  );
  const entities: ParsedAdEntity[] = [];

  for (const line of lines) {
    const entity = parseEntityLine(line);
    if (entity) {
      entities.push(entity);
    }
  }

  if (entities.length === 0 && !headerMatch) {
    return null;
  }

  return {
    entities,
    total: headerMatch ? Number(headerMatch[2]) : undefined,
    entityKind: headerMatch?.[3],
  };
}
